import Close from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import useMediaQuery from '@mui/material/useMediaQuery';
import type { Theme } from '@mui/material/styles';
import { PropsWithChildren, ReactNode } from 'react';

interface CustomInfoDialogProps {
	open: boolean;
	headerText: ReactNode;
	dialogTitle?: ReactNode;
	closeButtonLabel?: string;
	onClose: () => void;
}

export const CustomInfoDialog = ({
	open,
	headerText,
	dialogTitle,
	closeButtonLabel,
	onClose,
	children,
}: PropsWithChildren<CustomInfoDialogProps>) => {
	const fullScreen = useMediaQuery((theme: Theme) =>
		theme.breakpoints.only('xs')
	);

	return (
		<Dialog open={open} onClose={onClose} fullScreen={fullScreen}>
			{dialogTitle && (
				<DialogTitle sx={{ marginRight: 2 }}>
					{dialogTitle}
					<IconButton
						aria-label="close"
						onClick={onClose}
						sx={(theme) => ({
							position: 'absolute',
							right: theme.spacing(1),
							top: theme.spacing(1.5),
							color: theme.palette.grey[500],
						})}>
						<Close />
					</IconButton>
				</DialogTitle>
			)}
			<DialogContent>
				<Alert severity="info">
					<AlertTitle variant="h6">{headerText}</AlertTitle>
					{children}
				</Alert>
			</DialogContent>
			{closeButtonLabel && (
				<DialogActions>
					<Button
						variant="contained"
						color="secondary"
						disableElevation
						onClick={onClose}>
						{closeButtonLabel}
					</Button>
				</DialogActions>
			)}
		</Dialog>
	);
};
